<template>
    <div class="study-search">
        <div class="search-cont">
            <div class="cont">   
                <div class="cont-input">
                    <el-input placeholder="请输入搜索内容" v-model="searchVal" class="input-with-select" clearable> 
                        <el-button type="primary" slot="append" icon="el-icon-search" @click="search_click" >搜索</el-button>  
                    </el-input> 
                </div>
                <div>
                    <el-button type="primary" @click="clear_search" >清空</el-button>  
                    <!-- 老版本无检索后效果 -->
                    <!-- <el-button type="primary" @click="advanced_click">高级检索</el-button>   -->
                </div>
            </div> 
            <div class="hot-word">
                热搜词：<span v-for="(item,index) in hotwordList" :key="index" @click="hotWord(item)">{{item.val}}</span> 
            </div>  
        </div>
    </div>
</template>

<script>
import { mapState,mapMutations } from 'vuex';
export default {
    props: {
        sourceType: {
            type: String,
            default: '',
        },

        // 热搜词列表，可传入覆盖；不传则使用默认值
        hotwordList: {
            type: Array,
            default() {
                return [
                    { val: '黄帝内经' },
                    { val: '伤寒论' },
                    { val: '本草纲目' },
                    { val: '内经' },
                ];
            },
        },
    },
    data () {
        return { }
    },
    computed: {
        searchVal: {
            get() {
                return this.$store.state.study.searchVal;
            },
            set(val) {
                this.$store.commit('setSearchVal', val);
            }
        }
    },
    mounted(){
        if(this.$route.query.searchWord){
            this.setSearchVal(this.$route.query.searchWord);
        }
    },
    methods: {
        ...mapMutations(['setSearchVal']),
        hotWord(item){ 
            this.setSearchVal(item.val);
            this.search_click(); 
        },
        clear_search(){
            this.setSearchVal('');
        },
        search_click(){ 
            //studyMore和studyDetails点击搜索时，直接调用searchClick事件
            if(this.sourceType=='studyMore'||this.sourceType=='studyDetails'||this.sourceType=='topic'){
                this.$emit('searchClick')
                return
            } 
            if(this.$route.path=='/studyPage'){
                this.$emit('searchClick')
            }else{
                this.$router.push({
                    path:'/studyPage',  
                    query:{ 
                        sourceType:'',
                        searchWord: this.searchVal,
                    }
                })
            }
        },
        advanced_click(){
            this.$emit('advancedSearch')
        }
    }
}
</script>

<style lang="less" scoped>
.study-search{
    width: 100%;
    padding: 50px 0 30px; 
    background: url(../../../assets/images/study/study-bg.jpg) no-repeat;
    background-size: cover;
    margin-bottom: 20px;
    .search-cont{
        width: 1100px;
        padding: 40px 70px;
        background: rgba(255, 255, 255, .7);
        margin: 0 auto;
        border-radius: 8px;
        ::v-deep .el-input-group__append{
            background: #386DE8;
            color: #fff;
            // border: 1px solid #386DE8; 
        }
        .cont{
            display: flex;
            justify-content: space-between;
            .cont-input{
                width: 870px;
            }
        }
        .hot-word{
            padding-top:14px;
            span{
                cursor: pointer;
                color: #386DE8;
                margin: 0 6px;
            }
        }    
    }
}
</style>